module.exports = __webpack_public_path__ + "static/media/data1.a00f771e.jpg";